import React, { Component } from "react";
import "./DashboardSection.css";

class DashboardSection extends Component {
	render() {
		return (
			<div className="dashboard-section">
				<div className="dashboard-section-header">
					<p>{this.props.sectionHeader}</p>
				</div>
				<div className="dashboard-section-content" style={{justifyContent: this.props.data.length === 0 ? "center": "flex-start"}}>
					{this.props.data.length === 0 ? (
						<p className="dashboard-error-p">{`Unable to find ${this.props
							.sectionHeader}`}</p>
					) : (
						this.props.renderBody
					)}
				</div>
			</div>
		);
	}
}

export default DashboardSection;


// WEBPACK FOOTER //
// ./src/components/DashboardHome/DashboardSection/DashboardSection.js